import './App.scss';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { ReactQueryDevtools } from 'react-query/devtools';
import { DataEnvironmentProvider } from './contexts/DataEnvironmentContext';
import { BrowserRouter } from 'react-router-dom';
import { RootRoutes } from './RootRoutes';
import { GlobalStyle, THEME } from './Theme';
import { ThemeProvider } from 'styled-components';
import Header from 'components/Header/Header';
import { Auth } from 'components/Auth';
import { useState } from 'react';
import {
  ConfigCatProvider,
  createFlagOverridesFromMap,
  OverrideBehaviour,
} from 'configcat-react';
import loader from 'config/loader';
import {
  ConfigCatLocalOverrides,
  REACT_APP_CONFIG_CAT_KEY,
} from 'FeatureFlags';
import { Wrapper } from 'components/Wrapper/Wrapper';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const [fullName, setFullName] = useState('');
  const configCatKey =
    (loader.getConfigValue(REACT_APP_CONFIG_CAT_KEY) as string) ?? 'sdk_key';

  const flagOverrides = createFlagOverridesFromMap(
    ConfigCatLocalOverrides,
    configCatKey === 'sdk_key'
      ? OverrideBehaviour.LocalOnly
      : OverrideBehaviour.RemoteOverLocal
  );

  return (
    <ConfigCatProvider sdkKey={configCatKey} options={{ flagOverrides }}>
      <ThemeProvider theme={THEME}>
        <ToastContainer
          autoClose={5000}
          hideProgressBar
          pauseOnHover
          closeOnClick
        />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Auth onAuthenticated={setFullName}>
              <DataEnvironmentProvider>
                <ReactQueryDevtools initialIsOpen={true} />
                <Header fullName={fullName} />
                <Wrapper>
                  <RootRoutes />
                </Wrapper>
              </DataEnvironmentProvider>
            </Auth>
          </BrowserRouter>
        </QueryClientProvider>
        <GlobalStyle />
      </ThemeProvider>
    </ConfigCatProvider>
  );
}

export default App;
